import React, { createContext, useContext, useState, useEffect } from "react";
import {
  Modal,
  Box,
  TextField,
  Button,
  Typography,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import api from "../services/api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { set } from "date-fns";
import { Timer } from "@material-ui/icons";
import TimerCheckin from "./TimerCheckin";

const ModalContext = createContext();

const humores = [
  { emoji: "😢", label: "Triste", number: 1 },
  { emoji: "😟", label: "Desanimado", number: 2 },
  { emoji: "😐", label: "Neutro", number: 3 },
  { emoji: "🙂", label: "Feliz", number: 4 },
  { emoji: "😄", label: "Muito feliz", number: 5 },
];

export function ModalProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [humorSelecionado, setHumorSelecionado] = useState(3);
  const [descricao, setDescricao] = useState("");
  const [hasCheckin, setHasCheckin] = useState(false);
  const [startTime, setStartTime] = useState(null); // <-- ADICIONE ESTE ESTADO
  const [motivo, setMotivo] = useState("");
  const [elapsedTime, setElapsedTime] = useState(0); // tempo acumulado em ms

  const handleOpen = (id) => {
    setSelectedId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedId(null);
  };

  async function verificarCheckinAtivo(id) {
    try {
      const { data } = await api.get(`users/checkin/${id}`);

      if (data?.dt_final === null) {
        setStartTime(data.dt_inicio); // <-- ADICIONE ESTA LINHA

        if (data?.tipo_inicio === 1) {
          setHasCheckin(1); // em jornada
        } else if (data?.tipo_inicio === 2) {
          setHasCheckin(2); // em pausa
        } else if (data?.tipo_inicio === 3) {
          setHasCheckin(3); // retorno de pausa
        }
      } else {
        // O "else" original já cobre o caso do tipo_fim === 4
        setHasCheckin(false); // checkout realizado ou sem checkin
        setStartTime(null); // <-- ADICIONE ESTA LINHA
        setDescricao("");
        setHumorSelecionado(3);
      }
    } catch (err) {
      console.error("Erro ao verificar checkin ativo:", err);
      setHasCheckin(false);
      setStartTime(null); // <-- ADICIONE ESTA TAMBÉM
    }
  }

  useEffect(() => {
    if (selectedId) {
      verificarCheckinAtivo(selectedId);
    }
  }, [selectedId]);

  function horarioAtual() {
    const agora = new Date();
    const ano = agora.getFullYear();
    const mes = String(agora.getMonth() + 1).padStart(2, "0");
    const dia = String(agora.getDate()).padStart(2, "0");
    const hora = String(agora.getHours()).padStart(2, "0");
    const minuto = String(agora.getMinutes()).padStart(2, "0");
    const segundo = String(agora.getSeconds()).padStart(2, "0");
    const milissegundo = String(agora.getMilliseconds()).padStart(3, "0");
    return `${ano}-${mes}-${dia} ${hora}:${minuto}:${segundo}.${milissegundo}`;
  }

  // Salvar Checkin
  const handleSalvarCheckin = async () => {
    try {
      await api.post("/users/checkin", {
        id_usuario: selectedId,
        dt_inicio: horarioAtual(),
        dt_final: null,
        tipo_inicio: 1,
        tipo_fim: null,
        sistema: 2,
        id_obs: null,
        humor: humorSelecionado,
        descreva: descricao,
      });

      setHasCheckin(1);
      handleClose();

      toast.success("✅ Check-in realizado com sucesso!");
    } catch (error) {
      console.error(error);
      toast.error("❌ Erro ao realizar check-in!");
    }
  };

  // Pausa
  const handlepausa = async () => {
    try {
      await api.post("/users/pausa", {
        id_usuario: selectedId,
        dt_inicio: horarioAtual(),
        dt_final: null,
        tipo_inicio: 2,
        tipo_fim: null,
        sistema: 2,
        id_obs: null,
        humor: humorSelecionado,
        descreva: descricao,
        motivo: motivo,
      });

      setHasCheckin(2);
      handleClose();
      toast.success("✅ Pausa realizada com sucesso!");
    } catch (error) {
      console.error(error);
      toast.error("❌ Erro ao realizar pausa!");
    }
  };
  // Retorno da pausa
  const handleRetorno = async () => {
    try {
      await api.post("/users/pausa", {
        id_usuario: selectedId,
        dt_inicio: horarioAtual(),
        dt_final: null,
        tipo_inicio: 3,
        tipo_fim: null,
        sistema: 2,
        id_obs: null,
        humor: humorSelecionado,
        descreva: descricao,
        motivo: motivo,
      });

      setHasCheckin(2);
      handleClose();
      toast.success("✅ Retorno registrado com sucesso!");
    } catch (error) {
      console.error(error);
      toast.error("❌ Erro ao registrar retorno!");
    }
  };

  // Checkout
  const handleSalvarCheckout = async () => {
    try {
      await api.post("/users/checkout", {
        id_usuario: selectedId,
        dt_final: horarioAtual(),
        tipo_fim: 4,
        sistema: 2,
        id_obs: null,
        humor: humorSelecionado,
        descreva: descricao,
      });

      setHasCheckin(false);
      handleClose();
      toast.success("✅ Checkout realizado com sucesso!");
    } catch (error) {
      console.error(error);
      toast.error("❌ Erro ao realizar checkout!");
    }
  };

  return (
    <ModalContext.Provider
      value={{
        handleOpen,
        handleClose,
        selectedId,
        hasCheckin,
        setHasCheckin,
        startTime,
      }}
    >
      {children}

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "#f0f0f0",
            boxShadow: 24,
            borderRadius: 2,
            width: 400,
            p: 0,
            overflow: "hidden",
          }}
        >
          {/* Cabeçalho */}
          <Box
            sx={{
              bgcolor: "#8e24aa",
              color: "#fff",
              p: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6">Jornada</Typography>
            <Button onClick={handleClose} sx={{ color: "#fff" }}>
              X
            </Button>
          </Box>

          {/* Conteúdo do modal */}
          {!hasCheckin ? (
            // ---- MODAL DE CHECKIN ----
            <Box
              sx={{ p: 3, display: "flex", flexDirection: "column", gap: 2 }}
            >
              {/* <Typography variant="subtitle1">
                ID do usuário: {selectedId}
              </Typography> */}

              <Box>
                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                  Humor:
                </Typography>
                <Box sx={{ display: "flex", gap: 1 }}>
                  {humores.map((h) => (
                    <IconButton
                      key={h.number}
                      onClick={() => setHumorSelecionado(h.number)}
                      sx={{
                        fontSize: 30,
                        backgroundColor:
                          humorSelecionado === h.number
                            ? "#8e24aa"
                            : "transparent",
                        color: humorSelecionado === h.number ? "#fff" : "#000",
                        "&:hover": {
                          backgroundColor: "#b57ce0",
                          color: "#fff",
                        },
                      }}
                    >
                      {h.emoji}
                    </IconButton>
                  ))}
                </Box>
              </Box>

              <TextField
                label="Descreva"
                placeholder="Descreva o que está sentindo.."
                variant="outlined"
                value={descricao}
                onChange={(e) => setDescricao(e.target.value)}
                multiline
                rows={4}
              />

              <Button
                variant="contained"
                onClick={handleSalvarCheckin}
                sx={{
                  bgcolor: "#8e24aa",
                  "&:hover": { bgcolor: "#6a1b9a" },
                }}
              >
                CHECKIN
              </Button>
            </Box>
          ) : hasCheckin === 1 ? (
            // ---- MODAL DE CHECKOUT ----
            <Box
              sx={{ p: 3, display: "flex", flexDirection: "column", gap: 2 }}
            >
              <TextField
                label="Id Usuário"
                value={selectedId}
                disabled
                fullWidth
                size="small"
              />

              <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                <FormControl fullWidth size="small">
                  <InputLabel style={{ marginBottom: 2 }}>Motivo</InputLabel>
                  <Select
                    value={motivo}
                    onChange={(e) => setMotivo(e.target.value)}
                  >
                    <MenuItem value="ALMOÇO">ALMOÇO</MenuItem>
                    <MenuItem value="BANHEIRO">BANHEIRO</MenuItem>
                    <MenuItem value="DESCANSO">DESCANSO</MenuItem>
                    <MenuItem value="TREINAMENTO">TREINAMENTO</MenuItem>
                  </Select>
                </FormControl>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handlepausa}
                >
                  PAUSA
                </Button>
              </Box>

              <Button
                variant="contained"
                onClick={handleSalvarCheckout}
                sx={{
                  background: "linear-gradient(90deg, #6a11cb, #8e2de2)",
                  fontWeight: "bold",
                }}
              >
                CHECKOUT
              </Button>
            </Box>
          ) : hasCheckin === 2 ? (
            // ---- MODAL DE RETORNO ----
            <Box
              sx={{ p: 3, display: "flex", flexDirection: "column", gap: 2 }}
            >
              <TextField
                label="Ramal"
                value={selectedId}
                disabled
                fullWidth
                size="small"
              />

              <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                <FormControl fullWidth size="small" disabled>
                  <InputLabel>Motivo</InputLabel>
                  <Select value="ALMOÇO">
                    <MenuItem value="ALMOÇO">ALMOÇO</MenuItem>
                  </Select>
                </FormControl>

                <Button
                  variant="contained"
                  sx={{ bgcolor: "red", "&:hover": { bgcolor: "#c62828" } }}
                  onClick={handleRetorno}
                >
                  RETORNO
                </Button>
              </Box>

              <Button variant="contained" disabled sx={{ bgcolor: "grey.400" }}>
                CHECKOUT
              </Button>
            </Box>
          ) : hasCheckin === 3 ? (
            // ---- MODAL DE CHECKOUT ----
            <Box
              sx={{ p: 3, display: "flex", flexDirection: "column", gap: 2 }}
            >
              <TextField
                label="Id Usuário"
                value={selectedId}
                disabled
                fullWidth
                size="small"
              />

              <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                <FormControl fullWidth size="small">
                  <InputLabel style={{ marginBottom: 2 }}>Motivo</InputLabel>
                  <Select
                    value={motivo}
                    onChange={(e) => setMotivo(e.target.value)}
                  >
                    <MenuItem value="ALMOÇO">ALMOÇO</MenuItem>
                    <MenuItem value="BANHEIRO">BANHEIRO</MenuItem>
                    <MenuItem value="DESCANSO">DESCANSO</MenuItem>
                    <MenuItem value="TREINAMENTO">TREINAMENTO</MenuItem>
                  </Select>
                </FormControl>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handlepausa}
                >
                  PAUSA
                </Button>
              </Box>

              <Button
                variant="contained"
                onClick={handleSalvarCheckout}
                sx={{
                  background: "linear-gradient(90deg, #6a11cb, #8e2de2)",
                  fontWeight: "bold",
                }}
              >
                CHECKOUT
              </Button>
            </Box>
          ) : null}
        </Box>
      </Modal>
    </ModalContext.Provider>
  );
}

export function useModal() {
  return useContext(ModalContext);
}
